<section-panel
  [internal]="internal"
  [paddings]="!internal ? 'large' : 'none'"
  [hintContent]="hintContent"
>
  <div class="wrapper">
    <ion-toggle
      #toggle
      [(ngModel)]="value"
      [disabled]="disabled"
      [style]="'--activeColor: ' + activeColor"
      (ionChange)="onToggle($event)"
    >
      <span class="label" [ngClass]="{'lightFont': lightFont}">{{ title }}</span>
    </ion-toggle>
  </div>

  <ion-accordion-group #expander [value]="expandExpander" [disabled]="disabled">
    <ion-accordion [value]="true" toggleIcon="">
      <ion-item slot="header"></ion-item>
      <div class="expander" slot="content" #expandableContent [@contentFade]="fadeState">
        <ng-content></ng-content>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</section-panel>
